import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header";
import Footer from "../Footer";
import { second, third } from "./data"; // ✅ STATIC DATA
import { ProgramIllustration } from "../../Assets";
import Axios from "axios";
import "./Program.scss";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Snackbar, Alert } from "@mui/material";

const Program = () => {
  const modalRef = useRef();

  /* -------------------- STATE -------------------- */
  const [pop, setPop] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    name: "",
    mail_id: "",
    phone_number: "",
    role: "",
    college_name: "",
    year_of_studies: "",
    course_name: "",
    course_duration: "",
    time_slot: "",
  });

  /* -------------------- HANDLERS -------------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleFormReset = () => {
    setFormData({
      name: "",
      mail_id: "",
      phone_number: "",
      role: "",
      college_name: "",
      year_of_studies: "",
      course_name: "",
      course_duration: "",
      time_slot: "",
    });
    setPop(false);
  };

  /* -------------------- SUBMIT -------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "name",
      "mail_id",
      "phone_number",
      "role",
      "course_name",
      "course_duration",
      "time_slot",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        showSnackbar("Please fill all required fields", "error");
        return;
      }
    }

    try {
      await Axios.post(
        "https://thebettertomorrow.in/apiforms/api/registrations",
        {
          name: formData.name,
          mail_id: formData.mail_id,
          phone_number: formData.phone_number,
          role: formData.role,
          college_name: formData.college_name,
          year_of_studies: formData.year_of_studies,
          course_name: formData.course_name,
          course_duration: formData.course_duration,
          time_slot: formData.time_slot,
        }
      );

      handleFormReset();
      showSnackbar("Our team will contact you shortly!", "success");
    } catch (error) {
      console.error(error);
      showSnackbar("Something went wrong. Please try again.", "error");
    }
  };

  /* -------------------- OUTSIDE CLICK -------------------- */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setPop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* -------------------- JSX -------------------- */
  return (
    <div className="Program">
      <Header />

      {/* ---------- HERO ---------- */}
      <div className="top_div">
        <div className="top_left">
          <h2>Expert Guidance From Start To Summit</h2>
          <p>
            Designed and taught by Industrial Experts to help you transform your
            career into a dream job.
          </p>
          <h5>
            Navigate Your Career Journey <br /><br />
            Steering Your Journey Till Your Desired Destination
          </h5>
        </div>
        <div className="top_right">
          <img src={ProgramIllustration} alt="Program" />
        </div>
      </div>

      {/* ---------- UNIQUENESS ---------- */}
      <div className="Program_sec">
        {second.map((elem, index) => (
          <div
            key={index}
            className="Program_box"
            style={{ background: elem.color }}
          >
            <img src={elem.img} alt="icon" />
            <p>{elem.data}</p>
          </div>
        ))}
      </div>

      {/* ---------- COURSES ---------- */}
      <div className="Program_third">
        <h1 className="head1">Algo And Problem Solving Expertise</h1>
        <div className="Program_third_section">
          {third
            .filter((e) => e.topic === "Alog")
            .map((item, index) => (
              <div
                key={index}
                className="Program_Card"
                onClick={() => {
                  setPop(true);
                  setFormData((prev) => ({
                    ...prev,
                    course_name: item.data,
                  }));
                }}
              >
                <img src={item.img} alt={item.data} />
                <h2>{item.data}</h2>
                <div className="line" />
                <p>{item.tech}</p>
              </div>
            ))}
        </div>

        <h1 className="head2">Domain Expertise</h1>
        <div className="Program_third_section">
          {third
            .filter((e) => e.topic === "Domain")
            .map((item, index) => (
              <div
                key={index}
                className="Program_Card"
                onClick={() => {
                  setPop(true);
                  setFormData((prev) => ({
                    ...prev,
                    course_name: item.data,
                  }));
                }}
              >
                <img src={item.img} alt={item.data} />
                <h2>{item.data}</h2>
                <div className="line" />
                <p>{item.tech}</p>
              </div>
            ))}
        </div>
      </div>

{/* ---------- MODAL ---------- */}
{pop && (
  <div className="program-modal">
    <div className="program-modal__overlay">
      <div className="program-modal__card" ref={modalRef}>
        
        {/* Close */}
        <button
          className="program-modal__close"
          onClick={handleFormReset}
        >
          ×
        </button>

        {/* Header */}
        <div className="program-modal__header">
          <h2>Enroll for the Course</h2>
          <p>
            “Your future is created by what you do today, not tomorrow”
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="program-modal__form">

          <div className="form-grid">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="mail_id"
              placeholder="Email Address"
              value={formData.mail_id}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-grid">
            <input
              type="tel"
              name="phone_number"
              placeholder="Phone Number"
              value={formData.phone_number}
              onChange={handleChange}
              required
            />

            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="">Select Role</option>
              <option value="Student">Student</option>
              <option value="Working Professional">
                Working Professional
              </option>
            </select>
          </div>

          <div className="form-grid">
            <input
              type="text"
              name="college_name"
              placeholder={
                formData.role === "Working Professional"
                  ? "Company Name"
                  : "College Name"
              }
              value={formData.college_name}
              onChange={handleChange}
              required
            />

            <input
              type="number"
              name="year_of_studies"
              placeholder={
                formData.role === "Working Professional"
                  ? "Years of Experience"
                  : "Year of Study"
              }
              value={formData.year_of_studies}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-grid">
            <select
              name="course_duration"
              value={formData.course_duration}
              onChange={handleChange}
              required
            >
              <option value="">Course Duration</option>
              <option value="Fastrack course">Fast Track (1 Month)</option>
              <option value="Deep dive">Deep Dive (3 Months)</option>
            </select>

            <select
              name="time_slot"
              value={formData.time_slot}
              onChange={handleChange}
              required
            >
              <option value="">Preferred Time Slot</option>
              <option value="Daily_One_hour">Daily – 1 Hour</option>
              <option value="Only_weekends">Weekends Only</option>
            </select>
          </div>

          <button type="submit" className="submit-btn">
            Enroll Now
          </button>
        </form>
      </div>
    </div>
  </div>
)}



      <ToastContainer />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>

      <Footer />
    </div>
  );
};

export default Program;
